import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import {
  CompRef,
  PopulatedComponentContainerInfoMap,
} from '@wix/document-services-types';
import { DependencyToken } from '../dependencies';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class ExternalSlotsHandler extends AbstractExternalAPIHandler {
  getPopulatedContainerInfoMap(
    editorPointer: EditorPointer<CompRef>,
  ): PopulatedComponentContainerInfoMap {
    const getPopulatedContainerInfoMap = this.dependenciesContributor.get(
      DependencyToken.COMPONENTS_SLOTS_BUILDER_GET_DATA,
    );

    return getPopulatedContainerInfoMap(
      this.editorPointerAPI.getDocumentPointer(editorPointer),
    );
  }
}
